import { TransactionGift, TransactionStatus, TransactionType } from '../shared/enum'
import { ArrowWithStickDown, ArrowWithStickRight, BrokenImage, Key, Moneybox, Plus } from '../../assets/images'
import { ReferralStatisticsLevel } from '../services/api/User'
import { toAlias } from './string'
import get from 'lodash/get'

export const getTransactionTitleAlias = (type?: TransactionType) => {
  return `transaction.title.${toAlias(type)}`
}

export const getTransactionStatusAlias = (status?: TransactionStatus) => {
  return `transaction.title.${toAlias(status)}`
}

export const getTransactionIcon = (type?: TransactionType) => {
  switch (type) {
    case TransactionType.MONEYBOX:
      return Moneybox
    case TransactionType.TRANSFER_BALANCE:
      return ArrowWithStickRight
    case TransactionType.WITHDRAW:
    case TransactionType.RECEIVED_TRANSFER:
      return ArrowWithStickDown
    case TransactionType.BALANCE:
      return Plus
    case TransactionType.INSTALLMENT_PAYMENT:
    case TransactionType.SINGLE_PAYMENT:
    case TransactionType.CORRECTION:
    case TransactionType.GIFT_SHARES:
    case TransactionType.GIFT_BALANCE:
    case TransactionType.REFERRAL_PRIZE:
      return Plus
    case TransactionType.NFT_PAYMENT:
      return Key
    default:
      return BrokenImage
  }
}

export const getTransactionColorClassname = (status: TransactionStatus, cent: number) => {
  if (status === TransactionStatus.IN_PROGRESS) {
    return 'gray'
  }
  if (status === TransactionStatus.REJECTED) {
    return 'red'
  }
  if (cent > 0) {
    return 'green'
  }
}

export const isShowProjectIcon = (type?: TransactionType) => {
  switch (type) {
    case TransactionType.SINGLE_PAYMENT:
    case TransactionType.INSTALLMENT_PAYMENT:
    case TransactionType.GIFT_SHARES:
    case TransactionType.REFERRAL_PRIZE:
      return true
    default:
      return false
  }
}

export const referralColors = {
  1: '#FD32D0',
  2: '#7F32FD',
  3: '#C832FD',
  other: '#347DFE',
}
export const getReferralColors = (depth?: ReferralStatisticsLevel | number) => {
  let valid = depth as ReferralStatisticsLevel
  if (typeof depth === 'number' && (depth > 3 || depth < 1)) {
    valid = 'other'
  }
  return referralColors[valid]
}
export const transactionColors = {
  [TransactionType.REFERRAL_PRIZE]: '#01E676',
  [TransactionType.MONEYBOX]: '#83FFC2',
  [TransactionType.INSTALLMENT_PAYMENT]: '#90BDFF',
  [TransactionType.SINGLE_PAYMENT]: '#347DFE',
  [TransactionType.GIFT_BALANCE]: '#BDD7FF',
  [TransactionType.GIFT_SHARES]: '#BDD7FF',
  [TransactionType.WITHDRAW]: '#FFC224',
  [TransactionType.TRANSFER_BALANCE]: '#5C34FE',
  [TransactionType.RECEIVED_TRANSFER]: '#7B5AFF',
  [TransactionType.BALANCE]: '#FF9B70',
  [TransactionType.CORRECTION]: '#D6FFEB',
}
export const getTransactionColors = (type: TransactionType) => {
  return get(transactionColors, type) || ''
}

export const referralPercent = {
  1: 10,
  2: 5,
  3: 2,
  other: 23,
}
export const getReferralPercent = (depth?: ReferralStatisticsLevel | number) => {
  let valid = depth as ReferralStatisticsLevel
  if (typeof depth === 'number' && (depth > 3 || depth < 1)) {
    valid = 'other'
  }
  return referralPercent[valid]
}

export const isTransactionTypeGift = (t: TransactionType) => !!TransactionGift.find((type) => type === t)
